import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    return (
        <section className="ftco-about img ftco-section ftco-no-pb" id="about-section">
            <div className="container">
                <div className="row d-flex">
                    <div className="col-md-6 col-lg-5 d-flex">
                        <div className="img-about img d-flex align-items-stretch">
                            <div className="overlay"></div>
                            <div className="img d-flex align-self-stretch align-items-center" style={{ backgroundImage: 'url(images/bg_1.png)' }}>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-7 pl-lg-5 pb-5">
                        <div className="row justify-content-start pb-3">
                            <div className="col-md-12 heading-section" data-aos="fade-up">
                                <h1 className="big">About</h1>
                                <h2 className="mb-4">About Me</h2>
                                <p>
                                    Dedicated and performance-focused developer with 5 years of professional experience
                                    delivering scalable web applications and enterprise solutions.
                                    Committed to clean architecture, efficient code practices, and continuous technical growth.
                                </p>
                                <ul className="about-info mt-4 px-md-0 px-2">
                                    <li className="d-flex"><span>Name:</span> <span>Mohammad Sahil</span></li>
                                    <li className="d-flex"><span>Date of birth:</span> <span>October 28, 1998</span></li>
                                    <li className="d-flex"><span>Address:</span> <span>Sector 21-B, Chandigarh</span></li>
                                    <li className="d-flex"><span>Pin code:</span> <span>160022</span></li>
                                    <li className="d-flex"><span>Email:</span> <span>sahil021mohammad@gmail.com</span></li>
                                    <li className="d-flex"><span>Phone: </span> <span>+91 95924 07801</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="counter-wrap d-flex mt-md-3" data-aos="fade-up" data-aos-delay="100">
                            <div className="text">
                                <p className="mb-4">
                                    <span className="number" data-number="40">30+</span>
                                    <span> Project complete</span>
                                </p>
                                {/* <p><a href="#" className="btn btn-primary py-3 px-3">Download CV</a></p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
